import React, { useState } from "react";

import { Icon } from "components";
import { useMyContext } from "hooks";
import Utils from "utils/utils";
import {
  Wrapper,
  LeftContainer,
  RightContainer,
  StyledSpan,
  StyledStrong,
  StyledButton,
  StyledCurrencyInput,
} from "./styles";

import { useDebounce } from "react-use";
import { useSelectInicialApplication } from "../../../state";

const InitialApplication = () => {
  const [initialApplication, setInitialApplication] =
    useSelectInicialApplication();

  const { t } = useMyContext();
  const { formatCurrency } = Utils();
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(initialApplication);
  const MIN_APPLICATION = 1;
  const MAX_APPLICATION = 1000000000;

  const handleChange = (event, _, floatvalue) => {
    event.preventDefault();
    if (floatvalue > MAX_APPLICATION) {
      setInputValue(MAX_APPLICATION);
    } else {
      setInputValue(floatvalue);
    }
  };

  const handleEditClick = () => {
    if (!isEditing) {
      setIsEditing(true);
    } else {
      if (initialApplication !== inputValue) {
        if (inputValue < MIN_APPLICATION) {
          setInputValue(MIN_APPLICATION);
          setInitialApplication(MIN_APPLICATION);
        } else if (inputValue > MAX_APPLICATION) {
          setInputValue(MAX_APPLICATION);
          setInitialApplication(MAX_APPLICATION);
        } else {
          setInitialApplication(inputValue);
        }
      }
      setIsEditing(false);
    }
  };

  useDebounce(
    () => {
      setInitialApplication(inputValue);
    },
    1000,
    [inputValue]
  );

  return (
    <Wrapper>
      <LeftContainer>
        <StyledStrong>
          {t["molecules:ConfigurationHeader:aplicaoInicial"]}
        </StyledStrong>
      </LeftContainer>
      <RightContainer>
        {isEditing ? (
          <StyledCurrencyInput
            value={inputValue}
            decimalSeparator=","
            thousandSeparator="."
            prefix="R$"
            allowNegative={false}
            onChangeEvent={handleChange}
            maxLength={17}
          />
        ) : (
          <StyledSpan>{formatCurrency(initialApplication)}</StyledSpan>
        )}
        <StyledButton onClick={handleEditClick}>
          <Icon iconname="edit" size="18" />
        </StyledButton>
      </RightContainer>
    </Wrapper>
  );
};

export default InitialApplication;
